import {
  PRODUCT_COUNT_ASSIGN_SUCCESS,
  PRODUCT_HISTORY_LIST_SUCCESS,
  PRODUCT_IMPORT_SUCCESS,
  PRODUCT_LIST_SUCCESS,
  PRODUCT_NEW_CARE_SUCCESS,
  PRODUCT_ONE_SUCCESS,
  PRODUCT_UPDATE_FILTER,

  PRODUCT_UPDATE_HOMEPAGE_FILTER,
  PRODUCT_HOMEPAGE_LIST_SUCCESS,
  PRODUCT_HOMEPAGE_ONE_SUCCESS,

  PRODUCT_LIMIT_UPDATE_HOMEPAGE_FILTER,
  PRODUCT_LIMIT_HOMEPAGE_LIST_SUCCESS,
  PRODUCT_LIMIT_HOMEPAGE_ONE_SUCCESS,
} from 'src/actions/product.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageProductFilter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageProductPage: 0,
    homepageProductLimit: DEFAULT_ROW_PER_PAGE,
  },
  homepageProductLimitFilter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    homepageProductLimitPage: 0,
    homepageProductLimitLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,

  homepageProductItems: [],
  homepageProductTotal: 0,
  homepageProductSelected: undefined,

  homepageProductLimitItems: [],
  homepageProductLimitTotal: 0,
  homepageProductLimitSelected: undefined,

  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0
}

const productReducer = (state = initState, action) => {
  switch (action.type) {
    case PRODUCT_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case PRODUCT_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case PRODUCT_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case PRODUCT_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageProductFilter !== 'undefined' && state.homepageProductFilter) {
        if (action.data.homepageProductPage == 'no_update' && typeof state.homepageProductFilter.homepageProductPage !== 'undefined') action.data.homepageProductPage = state.homepageProductFilter.homepageProductPage;
        if (action.data.homepageProductLimit == 'no_update' && typeof state.homepageProductFilter.homepageProductLimit !== 'undefined') action.data.homepageProductLimit = state.homepageProductFilter.homepageProductLimit;
      }
      return {
        ...state,
        homepageProductFilter: action.data,
      }
    }
    case PRODUCT_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageProductItems: action.data.homepageProductItems,
        homepageProductTotal: action.data.homepageProductTotal,
      }
    }
    case PRODUCT_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageProductSelected: action.data
      }
    }
    case PRODUCT_LIMIT_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageProductLimitFilter !== 'undefined' && state.homepageProductLimitFilter) {
        if (action.data.homepageProductLimitPage == 'no_update' && typeof state.homepageProductLimitFilter.homepageProductLimitPage !== 'undefined') action.data.homepageProductLimitPage = state.homepageProductLimitFilter.homepageProductLimitPage;
        if (action.data.homepageProductLimitLimit == 'no_update' && typeof state.homepageProductLimitFilter.homepageProductLimitLimit !== 'undefined') action.data.homepageProductLimitLimit = state.homepageProductLimitFilter.homepageProductLimitLimit;
      }
      return {
        ...state,
        homepageProductLimitFilter: action.data,
      }
    }
    case PRODUCT_LIMIT_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageProductLimitItems: action.data.homepageProductLimitItems,
        homepageProductLimitTotal: action.data.homepageProductLimitTotal,
      }
    }
    case PRODUCT_LIMIT_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageProductLimitSelected: action.data
      }
    }
    case PRODUCT_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case PRODUCT_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case PRODUCT_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case PRODUCT_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    default: {
      return state;
    }
  }
}
export default productReducer